export function isImageSignature(value?: string | null) {
	if (typeof value !== 'string') return false
	if (!value.startsWith('data:image')) return false

	const parts = value.split(',')
	if (parts.length < 2) return false

	return parts[0].includes('data:image') && parts[1].length > 0
}

export function exportTrimmedSignature(canvas: HTMLCanvasElement) {
	const context = canvas.getContext('2d')
	if (!context) return null

	const { width, height } = canvas
	const { data } = context.getImageData(0, 0, width, height)

	let minX = width
	let minY = height
	let maxX = -1
	let maxY = -1

	for (let y = 0; y < height; y += 1) {
		for (let x = 0; x < width; x += 1) {
			const alpha = data[(y * width + x) * 4 + 3]

			if (alpha === 0) continue

			minX = Math.min(minX, x)
			minY = Math.min(minY, y)
			maxX = Math.max(maxX, x)
			maxY = Math.max(maxY, y)
		}
	}

	if (maxX < minX || maxY < minY) return null

	const padding = 12
	const cropX = Math.max(minX - padding, 0)
	const cropY = Math.max(minY - padding, 0)
	const cropWidth = Math.min(maxX - minX + 1 + padding * 2, width - cropX)
	const cropHeight = Math.min(maxY - minY + 1 + padding * 2, height - cropY)

	const trimmedCanvas = document.createElement('canvas')

	const maxWidth = 400
	const scale = cropWidth > maxWidth ? maxWidth / cropWidth : 1

	trimmedCanvas.width = cropWidth * scale
	trimmedCanvas.height = cropHeight * scale

	const trimmedContext = trimmedCanvas.getContext('2d')
	if (!trimmedContext) return null

	trimmedContext.clearRect(0, 0, trimmedCanvas.width, trimmedCanvas.height)
	trimmedContext.drawImage(
		canvas,
		cropX,
		cropY,
		cropWidth,
		cropHeight,
		0,
		0,
		trimmedCanvas.width,
		trimmedCanvas.height,
	)

	return trimmedCanvas.toDataURL('image/png')
}
